module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-out",
      rawName: "v-click-out",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "btn-group dropdown",
    class: {
      open: _vm.open
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-dark",
    attrs: {
      "data-toggle": "dropdown",
      "tabindex": "1",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggle($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear m-r-xs"
  }), _vm._v(" Ações complementares à preparação do leilão "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu no-padder"
  }, [_c('li', [_c('a', {
    attrs: {
      "tabindex": "2"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('forcarOutraImportacao')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-star-o fa-fw"
  }), _vm._v(" Fazer nova importação para este leilão")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "tabindex": "2"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('importacaoSecundaria')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload fa-fw"
  }), _vm._v(" Importação Secundária (CSV)")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-600848b8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/BtnAcoesComplementaresPreparacaoLeilao.vue
// module id = 1706
// module chunks = 17